const algoliaAppId = '8I80D7Z4UB';
const algoliaAppKey = '27879b4a4b1e5ca5f2270e819b464428';

// Select Algolia Index
const allowedCountries = ['US', 'NZ', 'AU'];
const country = Shopify.country?.toUpperCase() || 'AU';
const finalCountry = allowedCountries.includes(country) ? country : 'AU';
const algoliaIndexName = 'shopify_products_' + finalCountry.toLowerCase();

/**
 * Fills a product card template with data
 * Works with templates that have data-field attributes OR standard Shopify HTML structure
 * @param {Object} data - Product data to fill in
 * @param {string} templateId - ID of the template element (default: 'product-card-template')
 * @returns {HTMLElement} - Filled product card element
 */
function fillProductCard(data, templateId = 'product-card-template') {
  // Get the template and clone it
  const template = document.getElementById(templateId);
  if (!template) {
    throw new Error(`Template with id "${templateId}" not found`);
  }

  const clone = template.content.cloneNode(true);
  return fillWithDataFields(clone, data);
}

/**
 * Fill template using data-field attributes
 */
function fillWithDataFields(clone, data) {
  const fieldHandlers = {
    'title': (el, value) => {
      if (value !== undefined && value !== null) {
        el.textContent = value;
      }
    },
    'url': (el, value) => {
      if (value !== undefined && value !== null) {
        // Find all <a> tags within or at this element
        const links = el.tagName === 'A' ? [el] : el.querySelectorAll('a');
        links.forEach(link => {
          link.href = value;
          link.removeAttribute('aria-disabled');
          link.removeAttribute('role');
        });
      }
    },
    'image': (el, value) => {
      if (value !== undefined && value !== null) {
        if (el.tagName === 'IMG') {
          el.src = value;
          el.srcset = value;
          if (data.image_alt) {
            el.alt = data.image_alt;
          }
        }
      }
    },
    'image_secondary': (el, value) => {
      if (value !== undefined && value !== null) {
        if (el.tagName === 'IMG') {
          el.src = value;
          el.srcset = value;
          if (data.image_secondary_alt) {
            el.alt = data.image_secondary_alt;
          }
        }
      } else {
        // Remove secondary image if not provided
        el.remove();
      }
    },
    'price': (el, value) => {
      if (value !== undefined && value !== null) {
        el.textContent = value;
      }
    },
    'sale-price': (el, value) => {
      if (value !== undefined && value !== null) {
        el.textContent = value;
      }
    },
    'compare-at-price': (el, value) => {
      if (value !== undefined && value !== null) {
        el.textContent = value;
      }
    },
    'sale-amount': (el, value) => {
      if (value !== undefined && value !== null) {
        el.textContent = value;
      }
    },
    'sale-percentage': (el, value) => {
      if (value !== undefined && value !== null) {
        el.textContent = value;
      }
    },
    'price-range': (el, value) => {
      if (value !== undefined && value !== null) {
        el.textContent = value;
      }
    },
    'material': (el, value) => {
      if (value !== undefined && value !== null) {
        el.textContent = value;
      } else {
        el.style.display = 'none';
      }
    },
    'vendor': (el, value) => {
      if (value !== undefined && value !== null) {
        el.textContent = value;
      } else {
        el.style.display = 'none';
      }
    },
    'badge-text': (el, value) => {
      if (value !== undefined && value !== null) {
        el.textContent = value;
      }
    },
    'rating-value': (el, value) => {
      if (value !== undefined && value !== null) {
        el.textContent = value;
      }
    },
    'rating-max': (el, value) => {
      if (value !== undefined && value !== null) {
        el.textContent = value;
      }
    },
    'rating-count': (el, value) => {
      if (value !== undefined && value !== null) {
        el.textContent = value;
      }
    }
  };

  // Process each field
  Object.keys(data).forEach(fieldName => {
    const elements = clone.querySelectorAll(`[data-field="${fieldName}"]`);
    const handler = fieldHandlers[fieldName];

    if (handler) {
      elements.forEach(el => handler(el, data[fieldName]));
    }
  });

  return clone.firstElementChild || clone;
}

// Get HTML string instead of element
function fillProductCardHTML(data, templateId = 'product-card-template') {
  const element = fillProductCard(data, templateId);
  const wrapper = document.createElement('div');
  wrapper.appendChild(element);
  return wrapper.innerHTML;
}

// Don't use Algolia on collection pages (yet)
// e.g. /collections/

// Initialize Algolia client
const searchClient = algoliasearch(
  algoliaAppId,
  algoliaAppKey
);

const search = instantsearch({
  indexName: algoliaIndexName,
  searchClient,
  routing: {
    router: instantsearch.routers.history(),
    stateMapping: {
      stateToRoute(uiState) {
        const indexState = uiState[algoliaIndexName] || {};
        const { query, ...rest } = indexState;

        // use "q" in the URL instead of "query"
        return {
          q: query || undefined,
          ...rest,
        };
      },
      routeToState(routeState) {
        const { q, ...rest } = routeState;

        return {
          [algoliaIndexName]: {
            query: q || '',
            ...rest,
          },
        };
      },
    },
  },
});

const colorMap = {
  Orange: "#FFA500",
  Green: "#008000",
  Aqua: "#00FFFF",
  Violet: "#EE82EE",
  Brown: "#885418",
  Grey: "#808080",
  Gray: "#808080",
  Black: "#000000",
  Blue: "#0000FF",
  Teal: "#008080",
  Pink: "#FFC0CA",
  Purple: "#800080",
  Red: "#FF0000",
  White: "#FFFFFF",
  Yellow: "#FFFF04",
};

const makeItemTemplate = (useColor = false) => ({
  item(item) {
    const label = item.label.trim();
    const colorHex = useColor ? colorMap[label] || "#ccc" : "#333";
    return `
      <label class="ais-RefinementList-label">
        <input type="checkbox" class="ais-RefinementList-checkbox" value="${item.value}" ${
      item.isRefined ? "checked" : ""
    }>
        ${
          useColor
            ? `<span class="color-swatch" style="background-color:${colorHex};"></span>`
            : ""
        }
        <span class="ais-RefinementList-labelText">${label}</span>
        <span class="ais-RefinementList-count">(${item.count})</span>
      </label>
    `;
  },
});

// Replace filters and product results with algolia filters and products
const productGrid = document.querySelector('#product-grid');
const filterMaterialDesktop = document.querySelector('#filter-material-desktop');
if (productGrid && filterMaterialDesktop) {
  // Define our Dawn-style card builder
  const dawnHitsWidget = instantsearch.widgets.hits({
    container: '#product-grid',
    cssClasses: {
      list: 'grid product-grid grid--3-col-desktop grid--2-col-tablet-down',
      item: 'grid__item scroll-trigger animate--slide-in',
    },
    templates: {
      item(hit) {
        // Find lowest-price variant
        let lowestVariant = null;

        if (Array.isArray(hit.variants) && hit.variants.length > 0) {
          hit.variants.forEach(variant => {
            const price = parseFloat(variant.price);
            if (!isNaN(price)) {
              if (!lowestVariant || price < lowestVariant.price) {
                lowestVariant = {
                  price,
                  compareAtPrice: parseFloat(variant.compareAtPrice)
                };
              }
            }
          });
        }

        const price = lowestVariant?.price ?? null;
        const compare = lowestVariant?.compareAtPrice ?? null;
        const hasSale = !!(price !== null && compare !== null && compare > 0 && price < compare);
        const discountAmount = hasSale ? (compare - price).toFixed(2) : null;
        const discountPercent = hasSale ? Math.round(((compare - price) / compare) * 100) : null;
        const currencyCode = Shopify.currency.active;

        const productData = {
          title: hit.title,
          url: `/products/${hit.handle}`,
          material: hit.metafields.psg.wap_material,
          image: hit.image,
          image_alt: hit.title,
          price: `From $${price.toFixed(2)} ${currencyCode}`,
          "sale-price": hasSale ? `From $${price.toFixed(2)} ${currencyCode}` : null,
          "compare-at-price": hasSale ? `$${compare.toFixed(2)} ${currencyCode}` : null,
          "sale-amount": hasSale ? `$${discountAmount}` : null,
          "sale-percentage": hasSale ? `${discountPercent}%` : null,
          "badge-text": hasSale ? "Sale" : null
        };

        const cardHTML = fillProductCardHTML(productData);
        return cardHTML;
      },
    },
  });

  // Add the widget (but don’t start immediately)
  search.addWidgets([dawnHitsWidget]);

  search.addWidgets([
    // Desktop filters
    instantsearch.widgets.refinementList({
      container: "#filter-material-desktop",
      attribute: "metafields.psg.wap_material",
      operator: "or",
      sortBy: ["name:asc"],
      templates: makeItemTemplate(false),
    }),
    instantsearch.widgets.refinementList({
      container: "#filter-shape-desktop",
      attribute: "metafields.psg.wap_shape",
      operator: "or",
      sortBy: ["name:asc"],
      templates: makeItemTemplate(false),
    }),
    instantsearch.widgets.refinementList({
      container: "#filter-color-desktop",
      attribute: "metafields.psg.wap_colors",
      operator: "or",
      sortBy: ["name:asc"],
      templates: makeItemTemplate(true),
    }),
    instantsearch.widgets.pagination({
      container: "#pagination",
    }),
  ]);

  // On collection page, limit Algolia index results to those belonging to the current collection
  const path = window.location.pathname;
  const isCollection = path.startsWith('/collections/');
  const isSearchPage = path.startsWith('/search');

  // Base config
  let config = {};

  // If on a collection page
  if (isCollection) {
    const handle = path.split('/')[2]; // /collections/{handle}/...
    config.filters = `collections:"${handle}"`;
  }

  // Add to Algolia InstantSearch
  search.addWidgets([
    instantsearch.widgets.configure(config),
  ]);

  // Delay Algolia search start by 2 seconds
  setTimeout(() => {
    const grid = document.querySelector("#product-grid");
    if (grid) {
      grid.innerHTML = "";
    }

    // Bridge Autocomplete to InstantSearch
    const { connectSearchBox } = instantsearch.connectors;

    // Create a connector widget (no visible input)
    const customSearchBox = connectSearchBox((renderOptions, isFirstRender) => {
      const { refine } = renderOptions;

      if (isFirstRender) {
        // Listen for query updates coming from Autocomplete
        document.addEventListener('algolia:autocomplete-query', (e) => {
          refine(e.detail.query);
        });
      }
    });

    // Add the invisible connector so InstantSearch tracks query state
    search.addWidgets([customSearchBox()]);

    // Start Algolia search
    console.log("Starting Algolia search...");
    search.start();
  }, 0);
}

// Algolia autocomplete
document.addEventListener('DOMContentLoaded', function() {
  const searchClient = algoliasearch(
    algoliaAppId,
    algoliaAppKey
  );
  const index = searchClient.initIndex(algoliaIndexName);
  const { autocomplete } = window['@algolia/autocomplete-js'];

  const urlParams = new URLSearchParams(window.location.search);
  const initialQuery = urlParams.get('q') || '';

  const autocompleteInstance = autocomplete({
    container: '#algolia-autocomplete',
    placeholder: 'Search',
    openOnFocus: false,
    detachedMediaQuery: 'none', // Keep it inline

    initialState: {
      query: initialQuery,
    },

    onSubmit({ state }) {
      const query = state.query.trim();
      if (query) {
        // Default the filter to Material = 'Stretched Canvas'
        window.location.href = `/search?q=${encodeURIComponent(query)}&refinementList%5Bmetafields.psg.wap_material%5D%5B0%5D=Stretched%20Canvas`;
      }
    },

    getSources() {
      return [
        {
          sourceId: 'products',
          getItems({ query }) {
            if (!query) {
              return [];
            }
            return index
              .search(query, {
                hitsPerPage: 8,
                  filters: 'metafields.psg.wap_material:"Stretched Canvas"',
                })
              .then(({ hits }) => hits);
          },
          templates: {
            item({ item, html }) {
              return html`
                <div class="aa-ItemContent">
                  ${item.image
                    ? html`
                        <img
                          src="${item.image}"
                          alt="${item.title}"
                          class="algolia-product-image"
                        />
                      `
                    : ''}
                  <div class="algolia-product-info">
                    <div class="algolia-product-title">
                      ${item.title || item.product_title || 'Untitled Product'}
                    </div>
                    ${item.price
                      ? html`<div class="algolia-product-price">
                          $${item.price}
                        </div>`
                      : ''}
                  </div>
                </div>
              `;
            },
          },
          onSelect({ item, setIsOpen }) {
            if (item.handle) {
              window.location.href = '/products/' + item.handle;
            }
            setIsOpen(false);
          },
        },
      ];
    },
  });

  // Sync Algolia input with hidden field for form submission fallback
  const algoliaInput = document.querySelector('#algolia-autocomplete .aa-Input');
  const hiddenInput = document.querySelector('#algolia-query-hidden');
  const resetButton = document.querySelector('#algolia-reset-button');

  if (algoliaInput && hiddenInput) {
    algoliaInput.addEventListener('input', function() {
      hiddenInput.value = this.value;

      // Toggle reset button visibility
      if (resetButton) {
        if (this.value) {
          resetButton.classList.remove('hidden');
        } else {
          resetButton.classList.add('hidden');
        }
      }
    });
  }

  // Handle reset button
  if (resetButton && algoliaInput) {
    resetButton.addEventListener('click', function(e) {
      e.preventDefault();
      // Use Algolia's setQuery method to properly clear the input
      autocompleteInstance.setQuery('');
      hiddenInput.value = '';
      algoliaInput.focus();
      resetButton.classList.add('hidden');
    });
  }

  // Apply Dawn's field input classes to Algolia input
  if (algoliaInput) {
    algoliaInput.classList.add('search__input', 'field__input');
  }

  document.querySelectorAll('form.search').forEach((searchForm) => {
    searchForm.style.visibility = 'visible';
  });
});

// Mobile filters
document.addEventListener('DOMContentLoaded', function() {
  const drawer = document.getElementById('main-search-filters');
  const toggle = document.querySelector('.filters-toggle');

  if (!drawer || !toggle) return;

  // Open drawer
  toggle.addEventListener('click', () => {
    drawer.classList.add('open');
  });

  document.querySelector('.filters-clear').addEventListener('click', () => {
    search.helper.clearRefinements().search();
  });

  document.querySelectorAll('.filters-close, .filters-done').forEach(el => {
    el.addEventListener('click', () => {
      drawer.classList.remove('open');
    });
  });
});

// Mobile search bar
document.addEventListener('DOMContentLoaded', () => {
  const searchSummary = document.querySelector('.header__search summary');
  const searchForm = document.getElementById('inline-search-form');
  const overlay = document.querySelector('.mobile-search-overlay');
  const closeBtn = document.querySelector('.mobile-search-close');

  if (!searchSummary || !searchForm) return;

  // Open Algolia search
  function openSearch() {
    searchForm.classList.add('open');
    overlay?.classList.add('open');
    closeBtn?.classList.add('open');
    document.body.classList.add('overflow-hidden');

    // Focus Algolia input
    const input = searchForm.querySelector('.aa-Input');
    if (input) setTimeout(() => input.focus(), 150);
  }

  // Close Algolia search
  function closeSearch() {
    searchForm.classList.remove('open');
    overlay?.classList.remove('open');
    closeBtn?.classList.remove('open');
    document.body.classList.remove('overflow-hidden');
  }

  // Intercept the <summary> click (stop Shopify modal, open Algolia)
  searchSummary.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    const parentDetails = searchSummary.closest('details');
    if (parentDetails && parentDetails.hasAttribute('open')) {
      parentDetails.removeAttribute('open');
    }

    if (window.innerWidth < 990) {
      openSearch();
    }
  });

  // Close actions
  overlay?.addEventListener('click', closeSearch);
  closeBtn?.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeSearch();
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 990) {
      // Ensure body scroll is restored in desktop mode
      document.body.classList.remove('overflow-hidden');
    }
  });
});
